import { render, staticRenderFns } from "./menus-lv1.vue?vue&type=template&id=f15abfc2&"
import script from "./menus-lv1.vue?vue&type=script&lang=js&"
export * from "./menus-lv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports